export default {
  FETCH_USERS_REQUEST: 'FETCH_APPLICABLE_USERS_REQUEST',
  FETCH_USERS_SUCCESS: 'FETCH_APPLICABLE_USERS_SUCCESS',
  FETCH_USERS_FAILURE: 'FETCH_APPLICABLE_USERS_FAILURE'
}
